import { useNavigate, useParams } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import NotificationPreferences from 'components/notificationPreferences/NotificationPreferences';
import CircularProgress from 'components/shared/CircularProgress';
import { adminShowUser, adminUsersQueryKeys } from 'services/api/admin/users';

export default function AdminUserPreferences() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const { data: user, isLoading } = useQuery({
    queryKey: adminUsersQueryKeys.show(id!),
    queryFn: ({ signal }) =>
      adminShowUser(id!, signal, [
        'actingClient',
        'actingClient.clientGroupTypes',
        'actingClient.clientGroupTypes.groupType',
        'client',
        'enabledProviderTypes',
        'managedProviderTypes',
        'providedProviderTypes',
        'role',
      ]),
    enabled: !!id,
  });

  if (isLoading || !user) return <CircularProgress />;

  return <NotificationPreferences isAdmin user={user} onBack={() => navigate('/admin/users')} />;
}
